import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';
import foodBenefitManagerComponent from './foodBenefitManager.component';

let foodBenefitManagerModule = angular.module('food-benefit.foodBenefitManager', [
  uiRouter,
])

  .component('foodBenefitManager', foodBenefitManagerComponent)

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.FOOD_BENEFIT.MANAGER, {
        url: ROUTES.FOOD_BENEFIT.MANAGER,
        component: 'foodBenefitManager',
        data: {
          requiresAuth: true,
          requiresManager: true,
        },
      });
  })

  .name;

export default foodBenefitManagerModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/foodBenefitManager/foodBenefitManager.js